export enum SupplierTypeEnum {
    AGENT = 'Agent',
    FARMER = 'Farmer',
    DEALER = 'Dealer',
}

export enum RMInwardTypeEnum {
    IMPORT = 'Import',
    DOMESTIC = 'Domestic'
}

export enum QualityTypeEnum {
    QUALITY1 = 'Quality1',
    QUALITY2 = 'Quality2',
    QUALITY3 = 'Quality3'
}

export enum PackageTypeEnum {
    BOXES = 'Boxes',
    BAGS = 'Bags',
    CARTONS = 'Cartons',
    OPEN = 'Open',
    BALES = 'Bales'
}
